import { Button, Stack } from "@mui/material";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";

export const UploadButton = ({ saveImage }: { saveImage: any }) => {
  const handleFileChange = (event: any) => {
    saveImage(event.target.files[0]);
  };

  return (
    <Stack direction={"row"} alignSelf={"start"}>
      <Button
        startIcon={<DriveFolderUploadIcon />}
        variant="contained"
        component="label"
      >
        Ανεβαστε εικονα
        <input type="file" hidden onChange={handleFileChange} />
      </Button>
    </Stack>
  );
};
